module.exports = __webpack_public_path__ + "static/media/ArrowDown.7e3c31e6.svg";